import { sprintf } from 'sprintf-js';
import {
  IUnitConfiguration,
  UnitSystemConfiguration,
  Parameter,
  Direction,
  Unit,
  UnitSystem,
} from 'MeasurementsCalculations';
import { ReportKind } from 'Data';

// Class
export class UnitPresentation {
  unitSystemConfiguration: IUnitConfiguration;
  constructor(public unitSystem: UnitSystem) {
    this.unitSystemConfiguration = UnitSystemConfiguration[unitSystem];
  }

  overrideConfiguration(reportKind: ReportKind) {
    if (
      reportKind === ReportKind.puttingCompareReport ||
      reportKind === ReportKind.puttingMultiGroupReport ||
      reportKind === ReportKind.puttingSingleGroupReport ||
      reportKind === ReportKind.puttingSingleShotReport
    ) {
      if (this.unitSystemConfiguration[Parameter.LastData]) {
        this.unitSystemConfiguration[Parameter.LastData] = this.unitSystemConfiguration[
          Parameter.TrackedDistance
        ];
      }
      if (this.unitSystemConfiguration[Parameter.Total]) {
        this.unitSystemConfiguration[Parameter.Total] = this.unitSystemConfiguration[
          Parameter.Distance
        ];
      }
      if (this.unitSystemConfiguration[Parameter.Side]) {
        this.unitSystemConfiguration[Parameter.Side] = this.unitSystemConfiguration[
          Parameter.SideDistance
        ];
      }
    }
  }

  value(parameter: Parameter, radarValue: number | undefined) {
    if (!radarValue) return 0;

    var config = this.unitSystemConfiguration[parameter];
    return this.convert(config.getUnit(), radarValue);
  }

  unit(parameter: Parameter) {
    var config = this.unitSystemConfiguration[parameter];
    return config.getUnit();
  }

  displayUnit(parameter: Parameter) {
    var config = this.unitSystemConfiguration[parameter];
    return config.getDisplayUnit();
  }

  title(parameter: Parameter) {
    var config = this.unitSystemConfiguration[parameter];
    return config.getTitle();
  }

  toString(parameter: Parameter, radarValue: number) {
    if (radarValue != null) {
      var config = this.unitSystemConfiguration[parameter];
      var absValue = Math.abs(radarValue);
      switch (config.direction) {
        case Direction.LeftRight:
          var surfix = radarValue === 0 ? '' : radarValue > 0 ? 'R' : 'L';
          return sprintf(config.getFormat(), this.convert(config.getUnit(), absValue)) + surfix;
        case Direction.RightLeft:
          var surfix1 = radarValue === 0 ? '' : radarValue > 0 ? 'L' : 'R';
          return sprintf(config.getFormat(), this.convert(config.getUnit(), absValue)) + surfix1;
        case Direction.BeforeAfter:
          var surfix2 = radarValue === 0 ? '' : radarValue > 0 ? 'A' : 'B';
          return sprintf(config.getFormat(), this.convert(config.getUnit(), absValue)) + surfix2;
        default:
          return sprintf(config.getFormat(), this.convert(config.getUnit(), radarValue));
      }
    } else {
      return '';
    }
  }

  formatValue(parameter: Parameter, radarValue: number) {
    if (radarValue != null) {
      var config = this.unitSystemConfiguration[parameter];
      return sprintf(config.getFormat(), radarValue);
    }
    return null;
  }

  toStringNoDirection(parameter: Parameter, radarValue: number) {
    var config = this.unitSystemConfiguration[parameter];
    return sprintf(config.getFormat(), this.convert(config.getUnit(), radarValue));
  }

  //input allways radar data
  convert(unit: Unit, val: number) {
    switch (unit) {
      case Unit.UnitLess:
        return val;
      case Unit.MeterPerSecond:
        return val;
      case Unit.Meter:
        return val;
      case Unit.Centimeter:
        return val * 100;
      case Unit.Inch:
        return val * 39.3701;
      case Unit.Degree:
        return val;
      case Unit.RotationsPerMinute:
        return val;
      case Unit.Second:
        return val;
      case Unit.Celsius:
        return val;
      case Unit.FeetPerSecond:
        // meters pr second -> feet pr second
        return val * (1 / 0.3048);
      case Unit.MilesPerHour:
        //meters pr second -> miles pr hour
        return val * (3600 / 1609.344);
      case Unit.Yard:
        // meters -> yards
        return val * (1 / 0.9144);
      case Unit.Foot:
        //meters -> foot
        return val * (1 / 0.3048);
      case Unit.Fahrenheit:
        //celsius -> fahrenheit
        return (9 / 5) * val + 32;
      case Unit.Kelvin:
        //celsius -> kelvin
        return val + 273.15;
      case Unit.MeterPerSecondSquared:
        return val;
      case Unit.FeetPerSecondSquared:
        return val * (1 / 0.3048);
      case Unit.Percentage:
        return val * 100;
      case Unit.Millimeter:
        return val * 1000;
      default:
        return val;
    }
  }
}

//}
